<template>
	<div class="secondView">
		<div class="box1 mainCont" v-if="false">
			<!-- <div class="" v-html="articeObj.content"></div> -->
			<ul>
				<li class="br">
					<div class="yuan"><span></span></div>
					<h2>2021年</h2>
					<p>2021年，完成B轮，B+轮融资2021年，完成B轮，B+轮融资</p>
				</li>
				<li class="br">
					<div class="yuan"><span></span></div>
					<h2>2021年</h2>
					<p>2021年，完成B轮，B+轮融资2021年，完成B轮，B+轮融资</p>
				</li>
				<li class="br">
					<div class="yuan"><span></span></div>
					<h2>2021年</h2>
					<p>2021年，完成B轮，B+轮融资2021年，完成B轮，B+轮融资</p>
				</li>
				<li class="">
					<div class="yuan"><span></span></div>
					<h2>2021年</h2>
					<p>2021年，完成B轮，B+轮融资2021年，完成B轮，B+轮融资</p>
				</li>
			</ul>
		</div>
		<div class="box2 mainCont" v-if="false">
			<h3>荣誉资质</h3>
			<p class="name">honor qualification</p>
			<el-carousel height="260px" >
				<el-carousel-item v-for="item in 4" :key="item">
					<div class="mySwiper">
						<div class="swiper-slide" v-for="(item,index) in 4" :key="item">
							<!-- <img src="../../../../static//test/zz1.png" class="img" alt=""> -->
						  </div>
					</div>
				</el-carousel-item>
			</el-carousel>
			
		</div>
		<div class="box3 mainCont" v-if="false">
			<h3>合作伙伴</h3>
			<p class="name">Partners</p>
			<ul>
				<li>
					<img src="../../../../static//about/qItem3-img1.png" alt="">
				</li>
				<li>
					<img src="../../../../static//about/qItem3-img2.png" alt="">
				</li>
				<li>
					<img src="../../../../static//about/qItem3-img3.png" alt="">
				</li>
				<li>
					<img src="../../../../static//about/qItem3-img4.png" alt="">
				</li>
				<li>
					<img src="../../../../static//about/qItem3-img5.png" alt="">
				</li>
				<li>
					<img src="../../../../static//about/qItem3-img6.png" alt="">
				</li>
				<li>
					<img src="../../../../static//about/qItem3-img7.png" alt="">
				</li>
				<li>
					<img src="../../../../static//about/qItem3-img8.png" alt="">
				</li>
			</ul>
		</div>

		<div class="dex mainCont" v-html="content"></div>
	</div>
</template>

<script>
	import {getArtice} from '@/api/api'
	import {formatRichText} from "@/utils/utils"
	export default {
		name: 'secondView',
		components: {},
		data() {
			return {
				articeObj:{},
				content:'',
			};
		},
		mounted() {
			this.getArtice();
		},
		methods: {
			// 企业简介
			getArtice(){
				getArtice({type:'6'}).then(res => {
					this.articeObj = res.data;
					this.content = formatRichText(res.data.content)
				})
			},
		},
	};
</script>

<style lang="scss" scoped>
	.secondView {padding-top: 40px;
		.box1{padding-left: 144px;
			ul{padding-bottom: 40px;
				li{position: relative;padding-left: 46px;padding-bottom: 24px;
					&.br{border-left: 1px solid #EDEEF1;
					}
					.yuan{position: absolute;left: -12px;top: 0;width: 23px;height: 23px;background: #FFFFFF;border-radius: 50%;border: 1px solid #EDEEF1;display: flex;align-items: center;justify-content: space-around;
						span{width: 15px;height: 15px;background: #2F78FF;border-radius:50%;}
					}
					h2{color: #1F263F;font-size: 14px;font-weight: bold;line-height: 26px;margin-bottom: 12px;}
					p{padding: 7px 16px;background-color: #F5F8F9;color: #1F263F;font-size: 16px;}
				}
			}
		}
		.box2 {padding-bottom: 64px;
			h3{color: #1F263F;font-size: 36px;font-weight: bold;text-align: center;margin-bottom: 10px;}
			p.name{text-align: center;color: #A4A9B7;font-size: 18px;text-transform: uppercase;margin-bottom: 48px;}
			.mySwiper{margin-top: 40px;position: relative;padding-bottom: 40px;display: flex;align-items: center;justify-content: space-between;
				.swiper-slide{
					.img{width: 282px;height: 166px;}
				}
			}
			.swiper-next{position: absolute;top: 50%;bottom: 0;right: -80px;
				i{width: 50px;cursor: pointer;color: #EDEEF1;font-size: 36px;transition: all .3s;
					&:hover{color: #2F78FF;}
				}
			}
			.swiper-prev{position: absolute;top: 50%;bottom: 0;left: -80px;
				i{width: 50px;cursor: pointer;color: #EDEEF1;font-size: 36px;transition: all .3s;
					&:hover{color: #2F78FF;}
				}
			}
		}
		.box3 {padding-bottom: 64px;
			h3{color: #1F263F;font-size: 36px;font-weight: bold;text-align: center;margin-bottom: 10px;}
			p.name{text-align: center;color: #A4A9B7;font-size: 18px;text-transform: uppercase;margin-bottom: 40px;}
			ul{display: flex;align-items: center;flex-wrap: wrap;
				li{width: 24%;margin-right: 1.33%;margin-bottom: 16px;
					&:nth-child(4n+4){margin-right: 0;}
					img{width: 100%;}
				}
			}
		}
		.dex{color: #333;font-size: 16px;text-align: center;
			img{width: 100%;}
		}
	}
</style>


// WEBPACK FOOTER //
// src/views/aboutUs/components/secondView.vue